<script setup lang="ts">
import Banners from "~/components/TopBanner/Banners.vue";
import { useScroll } from "@vueuse/core";
import { useTemplateRef } from "vue";

const el = useTemplateRef("scrollTop");
const { y } = useScroll(el);
const route = useRoute();

watch(
  () => route.fullPath,
  () => {
    requestAnimationFrame(() => {
      y.value = 0;
    });
  }
);

</script>
<template>
  <div class="flex flex-col min-h-screen text-nl-green-100 h-auto bg-nl-yellow-100">
    <Banners />
    <Header />
    <div
      ref="scrollTop"
      class="flex-1 md:relative h-0 overflow-auto flex flex-col"
    >
      <div class="h-0 flex-1">
        <main id="main-content" tabindex="-1">
          <slot />
        </main>
        <Footer />
      </div>
    </div>
  </div>
</template>
